// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { FieldInputOption } from "@hex-insights/forms";
import { OrderDirection, ReportCardSectionLearningObjective } from "../../../Utilities";

type ReportCardSectionLearningObjectiveOrderField = never; // remove if order fields added

export type OrderFormValues = IndexForms.OrderFormValues;

export const initial: OrderFormValues = {
	field: null,
	direction: OrderDirection.Asc,
};

export function getInitial(initialFormValues?: Partial<OrderFormValues>) {
	return { ...initial, ...initialFormValues };
}

/**
 * Options for the "field" field in the order form of the ReportCardSectionLearningObjective model.
 */
export const fieldOptions: FieldInputOption<ReportCardSectionLearningObjectiveOrderField | null>[] = [
	{ label: "ID", value: null },
];

/**
 * Array of values for the "field" field in the order form of the ReportCardSectionLearningObjective model.
 */
export const fieldValues = fieldOptions.map((e) => e.value);

/**
 * Mapping from order fields of the ReportCardSectionLearningObjective model to their corresponding order type.
 */
export const fieldTypeMapping: IndexForms.OrderFieldTypeMapping<ReportCardSectionLearningObjectiveOrderField> = {};

/**
 * Mapping from order fields of the ReportCardSectionLearningObjective model to their corresponding field name.
 */
export const orderFieldToModelField: Record<
	ReportCardSectionLearningObjectiveOrderField,
	keyof ReportCardSectionLearningObjective
> = {};

/**
 * Mapping from field names of the ReportCardSectionLearningObjective model to their corresponding order field.
 */
export const modelFieldToOrderField: Record<string, ReportCardSectionLearningObjectiveOrderField> = {};
